import PerksDetailPage from '../../../src/client/pages/perks/detail';

const PerkPage = ({ perkId }: { perkId: string }) => {
  const match = {
    params: {
      slug: perkId,
    },
  };

  return <PerksDetailPage {...{ match }} />;
};

// @ts-expect-error - Automatic, Please fix when editing this file
export const getServerSideProps = async ({ params }) => ({
  props: {
    perkId: params.perkId,
  },
});

export default PerkPage;
